var showTooltip = false;

// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.limit,
        /* Optional */
//         loadProductFirst: true,
        //hasBestSellingSort: true,
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml':  '<div class="product-item">' +
                                '<div class="product-item-wrapper">' +
                                    '<div class="product-item-top">' +
                                        '<div class="product-item-media">' +
                                            '{{itemWishList}}' +
//                                             '{{itemCompareBtn}}' +
                                            '<a href="{{itemUrl}}" class="product-image" title="{{itemTitle}}">' +
                                                '<img {{itemEffectAppearClass}}src="{{itemThumbUrl}}" alt="{{itemTitle}}" id="{{itemUlId}}_{{itemId}}_main1_img"/>' +
                                            '</a>' +
                                        '</div>' +
                                        '{{itemSlider}}' +
                                        '{{itemSocial}}' +
                                        '<div class="product-item-hover product-qs-wrapper">{{itemQuickShopButton}}</div>' +
                                        '{{itemLabels}}' +
                                    '</div>' +
                                    '<div class="product-item-bottom">' +
                                        '<div class="product-details">' +
                                            '<div class="product-name">' +
                                                '<a href="{{itemUrl}}" title="{{itemTitle}}">{{itemTitle}}</a>' +
                                            '</div>' +
                                            '<div class="list-mode-description">' +
                                                '{{itemDes5}}' +
                                            '</div>' +
                                            '<div class="list-mode-description full-desc">' +
                                                '{{itemDes30}}' +
                                            '</div>' +
                                            '{{itemReview}}' +
                                            '{{itemPrice}}' +
                                        '</div>' +
                                        '<div class="actions product-item-hover actions-grid-mode {{itemNoCompareClass}}">' +
                                            '{{itemCartBtn}}' +
                                            '{{itemCompareBtn}}' +
                                        '</div>' +
                                        '<div class="actions actions-list-mode {{itemNoCompareClass}}">' +
                                            '{{itemReview}}' +
                                            '<div class="price-wrapper">' +
                                                '{{itemPrice}}' +
                                            '</div>' +
                                            '{{itemQuickShopButton}}' +
                                            '{{itemCartBtn}}' +
                                            '{{itemCompareBtn}}' +
                                        '</div>' +
  										'{{itemSwatch}}' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
//     'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_left + '"></span><span class="icon__fallback-text"><span class="brackets skeleton-loading" data-trans-key="general.pagination.previous">' + bcSfFilterConfig.label.pagination_previous + '</span></span></a></li>',
//     'previousDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_left + '"></span><span class="icon__fallback-text"><span class="brackets skeleton-loading" data-trans-key="general.pagination.previous">' + bcSfFilterConfig.label.pagination_previous + '</span></span></li>',
//     'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_right + '"></span><span class="icon__fallback-text"><span class="brackets skeleton-loading" data-trans-key="general.pagination.next">' + bcSfFilterConfig.label.pagination_next + '</span></span></a></li>',
//     'nextDisabledHtml': '<li><div class="btn btn--secondary btn--narrow btn--disabled"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_right + '"></span><span class="icon__fallback-text"><span class="brackets skeleton-loading" data-trans-key="general.pagination.next">' + bcSfFilterConfig.label.pagination_next + '</span></span></div></li>',
//     'pageItemHtml': '',
//     'pageItemSelectedHtml': '',
//     'pageItemRemainHtml': '',
//     'paginateHtml': '{{previous}} <li class="pagination__text"><span class="brackets skeleton-loading" data-trans-key="general.pagination.current_page">{{pageItems}}</span></li> {{next}}',
  	// Traditional Pagiantion
  	'previousActiveHtml': '<li><a href="{{itemUrl}} class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_left + '"></span><span class="icon__fallback-text"></span></li>',
    'previousDisabledHtml': '<li class="disabled" class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_left + '"></span><span class="icon__fallback-text"></span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_right + '"></span><span class="icon__fallback-text"></span></a></li>',
    'nextDisabledHtml': '<li class="disabled" class="btn btn--secondary btn--narrow"><span class="icon-cdz ' + bcSfFilterConfig.custom.icon_arrow_right + '"></span><span class="icon__fallback-text"></span></a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '{{sortingItems}}',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    var tooltipPos = bcSfFilterConfig.custom.tooltip_pos;

    // Add Wishlist
    var isShowWishlist = false;
    if (bcSfFilterConfig.custom.show_wishlist || bcSfFilterConfig.custom.force_display) {
        isShowWishlist = true;
    }
    var itemWishListHtml = '';
    if (isShowWishlist && bcSfFilterConfig.custom.enable_wishlist) {
        itemWishListHtml += '<div class="cdz-product-wishlist">';
        itemWishListHtml += '<div class="actions-secondary">';
        itemWishListHtml += '<a data-toggle="tooltip" data-data-original-title-trans="collections.product_item.wishlist" ';
        itemWishListHtml += 'data-data-original-title-default="' + bcSfFilterConfig.label.wishlist + '" data-original-title="' + bcSfFilterConfig.label.wishlist + '"';
        if (tooltipPos != '') {
            itemWishListHtml += 'data-placement="' + tooltipPos + '"';
        } else {
            itemWishListHtml += 'data-placement="top"';
        }
        itemWishListHtml += 'class="action link-wishlist" href="#" data-product-handle="{{itemHandle}}" data-product-title="{{itemTitle}}">';
        itemWishListHtml += '<span class="icon-cdz icon-cdz-heart-hover ' + bcSfFilterConfig.custom.icon_heart_hover + '"></span>';
        itemWishListHtml += '<span class="icon-cdz icon-cdz-heart ' + bcSfFilterConfig.custom.icon_heart + '"></span>';
        itemWishListHtml += '<span class="icon-header-hover"><span class="icon-cdz icon-cdz-heart-hover ' + bcSfFilterConfig.custom.icon_heart_hover + '"></span></span>';
        itemWishListHtml += '<span><span class="brackets skeleton-loading" data-trans-key="collections.product_item.wishlist">' + bcSfFilterConfig.label.wishlist + '</span></span>';
        itemWishListHtml += '</a>';
        itemWishListHtml += '</div>';
        itemWishListHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemWishList}}/g, itemWishListHtml);

    // itemEffectAppearClass
    var itemEffectAppearClass = '';
    if(bcSfFilterConfig.custom.use_effect_appear){
      	itemEffectAppearClass += 'class="lozad" data-';
    }
    itemHtml = itemHtml.replace(/{{itemEffectAppearClass}}/g, itemEffectAppearClass);

    // Add Thumbnail
    var itemThumbUrl = this.getFeaturedImage(images, bcSfFilterConfig.custom.image_size + '_crop_bottom');
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add ulId
    itemHtml = itemHtml.replace(/{{itemUlId}}/g, bcSfFilterConfig.custom.ulId);

    // Add Slider
    var itemSliderHtml = '';
    if (bcSfFilterConfig.custom.show_more_view == "true" || bcSfFilterConfig.custom.force_display) {
        itemSliderHtml += '<div class="more-views-slider visible-lg">';
        if (images.length > 0) {
            itemSliderHtml += '<ul class="image-list">';
            for (var i in images) {
                var image = images[i];
                itemSliderHtml += '<li class="item">';
                itemSliderHtml += '<a href="' + this.optimizeImage(image.src, bcSfFilterConfig.custom.image_size + '_crop_top') + '" data-target="#' + bcSfFilterConfig.custom.ulId + '_{{itemId}}_main1_img" class="switch-img';
                if (bcSfFilterConfig.custom.use_effect_appear) {
                    itemSliderHtml += ' wait-animated';
                }
                itemSliderHtml += '">';
                itemSliderHtml += '<img class="product-single__thumbnail-image';
                if (bcSfFilterConfig.custom.use_effect_appear == "true") {
                    itemSliderHtml += ' lozad';
                }
                itemSliderHtml += '"';
                if (bcSfFilterConfig.custom.use_effect_appear == "true") {
                    itemSliderHtml += 'style="min-height: 30px" data-';
                }
                itemSliderHtml += 'src="' + this.optimizeImage(image.src, bcSfFilterConfig.custom.more_view_size + '_crop_top') + '" alt="{{itemTitle}}" />';                
                itemSliderHtml += '</a>';
                itemSliderHtml += '</li>';
            }
            itemSliderHtml += '</ul>';            
        }
        itemSliderHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemSlider}}/g, itemSliderHtml);

    // Add Social
    var itemSocialHtml = '';
    if (bcSfFilterConfig.custom.show_social_share == "true" || bcSfFilterConfig.custom.force_display) {
        var url = encodeURIComponent(bcSfFilterConfig.shop.url + this.buildProductItemUrl(data, false));
        var title = encodeURIComponent(data.title);
        var desc = encodeURIComponent(data.body_html);
        var imageShare = this.getFeaturedImage(images);
        itemSocialHtml += '<div class="sharing-ctl">';
        itemSocialHtml += '<a href="javascript:void(0);" class="social-trigger" title="' + bcSfFilterConfig.label.share + '" data-title-trans="products.product.share" data-title-default="' + bcSfFilterConfig.label.share + '"><span class="icon-cdz icon-cdz-share ' + bcSfFilterConfig.custom.icon_share + '"></span></a>';
        itemSocialHtml += '<div class="social-icons">';
        itemSocialHtml += '<ul class="list-inline">';
        itemSocialHtml += '<li>';
        itemSocialHtml += '<a title="' + bcSfFilterConfig.label.share_on_facebook + '" data-title-trans="products.product.share_on_facebook" data-title-default="' + bcSfFilterConfig.label.share_on_facebook + '" target="_blank" href="//www.facebook.com/sharer.php?u=' + url + '" class="social-wrapper">';
        itemSocialHtml += '<span class="social-icon"><i class="fa fa-facebook"></i></span>';
        itemSocialHtml += '</a>';
        itemSocialHtml += '</li>';

        itemSocialHtml += '<li>';
        itemSocialHtml += '<a title="' + bcSfFilterConfig.label.share_on_twitter + '" data-title-trans="products.product.share_on_twitter" data-title-default="' + bcSfFilterConfig.label.share_on_twitter + '" target="_blank" href="//twitter.com/share?url=' + url + '&amp;text=' + title + '" class="social-wrapper">';
        itemSocialHtml += '<span class="social-icon"><i class="fa fa-twitter"></i></span>';
        itemSocialHtml += '</a>';
        itemSocialHtml += '</li>';

        itemSocialHtml += '<li>';
        itemSocialHtml += '<a title="' + bcSfFilterConfig.label.share_on_pinterest + '" data-title-trans="products.product.share_on_pinterest" data-title-default="' + bcSfFilterConfig.label.share_on_pinterest + '" target="_blank" href="//pinterest.com/pin/create/button/?url=' + url + '&amp;media=' + imageShare + '&amp;description=' + desc + '" class="social-wrapper">';
        itemSocialHtml += '<span class="social-icon"><i class="fa fa-pinterest"></i></span>';
        itemSocialHtml += '</a>';
        itemSocialHtml += '</li>';

        itemSocialHtml += '<li>';
        itemSocialHtml += '<a title="' + bcSfFilterConfig.label.share_on_google + '" data-title-trans="products.product.share_on_google" data-title-default="' + bcSfFilterConfig.label.share_on_google + '" target="_blank" href="//plus.google.com/share?url=' + url + '" class="social-wrapper">';
        itemSocialHtml += '<span class="social-icon"><i class="fa fa-google-plus"></i></span>';
        itemSocialHtml += '</a>';
        itemSocialHtml += '</li>';
        itemSocialHtml += '</ul>';

        itemSocialHtml += '</div>';
        itemSocialHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemSocial}}/g, itemSocialHtml);

    // Add Quick shop button
    var itemQuickShopButtonHtml = '';
    if (bcSfFilterConfig.custom.show_qs_btn == "true" || bcSfFilterConfig.custom.force_display) {
        itemQuickShopButtonHtml += '<a href="{{itemUrl}}" class="visible-lg qs-button button"';
        if (bcSfFilterConfig.custom.showTooltip == "true") {
            itemQuickShopButtonHtml += ' data-toggle="tooltip" data-data-original-title-trans="collections.product_item.quick_shop" data-data-original-title-default="' + bcSfFilterConfig.label.quick_shop + '" data-original-title="' + bcSfFilterConfig.label.quick_shop + '"';            
        }
        itemQuickShopButtonHtml += '>';
        itemQuickShopButtonHtml += '<span class="icon-cdz ' + bcSfFilterConfig.custom.icon_qs + '"></span>';
        itemQuickShopButtonHtml += '<span class="qs-title"><span class="brackets skeleton-loading" data-trans-key="collections.product_item.quick_shop">' + bcSfFilterConfig.label.quick_shop + '</span></span>';       
        itemQuickShopButtonHtml += '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (bcSfFilterConfig.custom.show_label || bcSfFilterConfig.custom.force_display) {
        itemLabelsHtml += '<div class="cdz-product-lbs">';
        if (bcSfFilterConfig.custom.sale_active && data.compare_at_price_min && onSale) {
            itemLabelsHtml += '<div class="lb-item lb-sale">';
            itemLabelsHtml += '<div class="lb-content">';
            if (bcSfFilterConfig.custom.sale_type == 'text' || bcSfFilterConfig.custom.sale_type == 'percent') {
                itemLabelsHtml += '<span style="color:' + bcSfFilterConfig.custom.sale_color + '; background-color: ' + bcSfFilterConfig.custom.sale_bkgcolor + ';">';
                if (bcSfFilterConfig.custom.sale_type == 'percent') {
                    itemLabelsHtml += '-';
                    itemLabelsHtml += Math.floor(((data.compare_at_price_min - data.price_min) * 100) / data.compare_at_price_min) + '%';
                } else {
                    itemLabelsHtml += bcSfFilterConfig.custom.sale_text;
                }
                itemLabelsHtml += '</span>';
            } else {
                itemLabelsHtml += '<img src="' + bcSfFilterConfig.custom.sale_img + '" alt="sale-label"/>';
            }
            itemLabelsHtml += '</div></div>';
        }
        itemLabelsHtml += '<div id="label-tag-{{itemHandle}}"></div>';
        itemLabelsHtml += '</div>'
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // itemDes5
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDes5 = (itemDescription.split(" ")).length > 5 ? itemDescription.split(" ").splice(0, 5).join(" ") : itemDescription.split(" ").splice(0, 5).join(" ");
    itemHtml = itemHtml.replace(/{{itemDes5}}/g, itemDes5);

    // itemDes30
    itemDes30 = (itemDescription.split(" ")).length > 30 ? itemDescription.split(" ").splice(0, 30).join(" ") : itemDescription.split(" ").splice(0, 30).join(" ");
    itemHtml = itemHtml.replace(/{{itemDes30}}/g, itemDes30);

    // itemReview
    var itemReviewHtml = '';
    if(this.getProductMetafield(data, 'spr', 'reviews') && bcSfFilterConfig.custom.use_shopify_review_app == "true") {
        itemReviewHtml += '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    }
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // itemPrice
    var itemPriceHtml = '<div class="product-price">';
    if (onSale) {
        if (priceVaries) {
            itemPriceHtml += '<span class="product-price__price product-price__sale">';
            itemPriceHtml += '<span class="price">' + this.formatMoney(data.price_min) + '</span>';
            itemPriceHtml += '<span class="product-price__sale-label"><span class="brackets skeleton-loading" data-trans-key="products.product.on_sale">' + bcSfFilterConfig.label.sale + '</span></span>';
            itemPriceHtml += '</span>';
            itemPriceHtml += '<span class="visually-hidden"><span class="brackets skeleton-loading" data-trans-key="products.product.regular_price">' + bcSfFilterConfig.label.regular_price + '</span></span>';
            itemPriceHtml += ' <span class="product-price__price compare_price"><span class="price">';
            itemPriceHtml += this.formatMoney(data.compare_at_price_min);
            itemPriceHtml += '</span></span>';
        } else {
            itemPriceHtml += '<span class="product-price__price product-price__sale">';
            itemPriceHtml += '<span class="price">' + this.formatMoney(data.price_min) + '</span>';
            itemPriceHtml += '<span class="product-price__sale-label"><span class="brackets skeleton-loading" data-trans-key="products.product.on_sale">' + bcSfFilterConfig.label.sale + '</span></span>';
            itemPriceHtml += '</span>';
            itemPriceHtml += '<span class="visually-hidden"><span class="brackets skeleton-loading" data-trans-key="products.product.regular_price">' + bcSfFilterConfig.label.regular_price + '</span></span>';
            itemPriceHtml += ' <span class="product-price__price compare_price"><span class="price">';
            itemPriceHtml += this.formatMoney(data.compare_at_price_min);
            itemPriceHtml += '</span></span>';
        }
    } else {
        if (priceVaries) {
            itemPriceHtml += '<span class="product-price__price"><span class="price">' + this.formatMoney(data.price_min) + '</span></span>';
        } else {
            itemPriceHtml += '<span class="visually-hidden"><span class="brackets skeleton-loading" data-trans-key="products.product.regular_price">' + bcSfFilterConfig.label.regular_price + '</span></span>';
            itemPriceHtml += '<span class="product-price__price"><span class="price">' + this.formatMoney(data.price_min) + '</span></span>';
        }
    }
    itemPriceHtml += '</div>';
    if (soldOut) {
        itemPriceHtml += '<span class="product-price__sold-out"><span class="brackets skeleton-loading" data-trans-key="products.product.sold_out">' + bcSfFilterConfig.label.sold_out + '</span></span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add no compare class
    var itemNoCompareClass = '';
    if (bcSfFilterConfig.custom.show_compare_btn == "false") {
        itemNoCompareClass += ' no-compare';
    }
    itemHtml = itemHtml.replace(/{{itemNoCompareClass}}/g, itemNoCompareClass);

    // Icon
    var icon_select_option = '<span class="icon-cdz ' + bcSfFilterConfig.custom.icon_select_option + '"></span>';
    var icon_cart_style4 = '<span class="icon-cdz ' + bcSfFilterConfig.custom.icon_cart_style4 + '"></span>'

    // Add to cart
    var itemCartBtnHtml = '';
    if (bcSfFilterConfig.custom.show_cart_btn == "true" || bcSfFilterConfig.custom.force_display) {
        itemCartBtnHtml += '<form method="post" enctype="multipart/form-data">';
        if (data.available) {
            itemCartBtnHtml += '<div class="hide clearfix">';
            itemCartBtnHtml += '<select name="id" >';
            if (onSale) {
                var found_one_in_stock = false;
                var found_variant_id;
                for (var i in data.variants) {
                    var variant = data.variants[i];
                    if (variant.available && variant.compare_at_price_min && found_one_in_stock == false) {
                        found_one_in_stock = true;
                        found_variant_id = variant.id;
                        break;
                    }
                }
                for (var i in data.variants) {
                    var variant = data.variants[i];
                    if (variant.id == found_variant_id) {
                        itemCartBtnHtml += '<option selected="selected" value="' + variant.id + '">' + variant.title + '</option>';
                    } else {
                        itemCartBtnHtml += '<option value="' + variant.id + '">' + variant.title + '</option>';
                    }
                }
            } else {
                var found_one_in_stock = false;
                var found_variant_id;
                for (var i in data.variants) {
                    var variant = data.variants[i];
                    if (variant.available && found_one_in_stock == false) {
                        found_one_in_stock = true;
                        itemCartBtnHtml += '<option selected="selected" value="' + variant.id + '">' + variant.title + '</option>';
                    } else {
                        itemCartBtnHtml += '<option value="' + variant.id + '">' + variant.title + '</option>';
                    }
                }
            }
            itemCartBtnHtml += '</select></div>';
        }
        itemCartBtnHtml += '<div class="status-cart">';
        // Tooltip
        var tooltipPlacement = tooltipPos != '' ? tooltipPos : 'top';
        var tooltip = '';
        if (showTooltip) {
            toolTip = 'data-toggle="tooltip" data-data-original-title-trans="products.product.add_to_cart" data-data-original-title-default="' + bcSfFilterConfig.label.add_to_cart + '" data-original-title="' + bcSfFilterConfig.label.add_to_cart + '" data-placement="' + tooltipPlacement + '"';
        }
        if (data.available) {
            if (data.variants.length == 1) {
                itemCartBtnHtml += '<button class="button btn-cart" type="submit" name="add"';
                if (bcSfFilterConfig.custom.showTooltip == "true") {
                    itemCartBtnHtml += 'data-toggle="tooltip" data-data-original-title-trans="products.product.add_to_cart" data-data-original-title-default="' + bcSfFilterConfig.label.add_to_cart + '" data-original-title="' + bcSfFilterConfig.label.add_to_cart + '" data-placement="';
                    if (tooltipPos != '') {
                        itemCartBtnHtml += tooltipPos;
                    } else {
                        itemCartBtnHtml += 'top';
                    }
                    itemCartBtnHtml += '"';
                }
                itemCartBtnHtml += '>';
                itemCartBtnHtml += '<span>';
                itemCartBtnHtml += icon_cart_style4;
                itemCartBtnHtml += '<span class="cart_title">';
                itemCartBtnHtml += '<span class="brackets skeleton-loading" data-trans-key="products.product.add_to_cart">' + bcSfFilterConfig.label.add_to_cart + '</span>';
                itemCartBtnHtml += '</span>';
                itemCartBtnHtml += '</span>';
                itemCartBtnHtml += '</button>';
            } else {
                itemCartBtnHtml += '<button class="button btn-cart select-option" type="button" data-url="{{itemUrl}}" ' + tooltip + '><span>' + icon_select_option + '<span class="cart_title"><span class="brackets skeleton-loading" data-trans-key="products.product.add_to_cart">' + bcSfFilterConfig.label.add_to_cart + '</span></span></span></button>';
            }
        } else {
            itemCartBtnHtml += '<button class="button btn-cart disabled" disabled="disabled" type="button" name="add" ' + tooltip + '><span>' + icon_cart_style4 + '<span class="cart_title"><span class="brackets skeleton-loading" data-trans-key="products.product.add_to_cart">' + bcSfFilterConfig.label.add_to_cart  + '</span></span></span></button>';
        }
        itemCartBtnHtml += '</div>';
        itemCartBtnHtml += '</form>';
    }
    itemHtml = itemHtml.replace(/{{itemCartBtn}}/g, itemCartBtnHtml);

    // Add Compare
    var isShowCompare = false;
    if (bcSfFilterConfig.custom.show_compare_btn == "true" || bcSfFilterConfig.custom.force_display) {
        var isShowCompare = true;
    }
    var itemCompareBtnHtml = '';
    if (isShowCompare && bcSfFilterConfig.custom.enable_compare) {
        itemCompareBtnHtml += '<a';
        if (showTooltip) {
            itemCompareBtnHtml += 'Codata-toggle="tooltip" data-original-title="' + bcSfFilterConfig.label.compare + '" data-data-original-title-trans="collections.product_item.compare" data-data-original-title-default="' + bcSfFilterConfig.label.compare + '"';
            if (tooltipPos) {
                itemCompareBtnHtml += 'data-placement="' + tooltipPos + '"';
            } else {
                itemCompareBtnHtml += 'data-placement="top"';
            }
        }
        itemCompareBtnHtml += ' href="{{itemUrl}}" class="button action link-compare" data-product-title="{{itemTitle}}">';
        itemCompareBtnHtml += '<span class="icon-cdz ' + bcSfFilterConfig.custom.icon_compare + '"></span><span class="compare-title"><span class="brackets skeleton-loading" data-trans-key="collections.product_item.compare">' + bcSfFilterConfig.label.compare + '</span></span></a>';
    }
    itemHtml = itemHtml.replace(/{{itemCompareBtn}}/g, itemCompareBtnHtml);
  
  	var itemSwatchHtml = '';
    var optionIndex = data.options_with_values.findIndex(function(e) { return e.name == 'size'; });
    var options = data.options_with_values.filter(function(e) { return (e.name).toLowerCase() == 'size'; });
    if (typeof options[0] !== 'undefined') {
      itemSwatchHtml += '<div class="product-variants">';
      itemSwatchHtml += '<ul class="sizelist">';

      var avaiVariants = [];
      for (var i = 0; i < data['variants'].length; i ++) {
        if (data['variants'][i].hasOwnProperty('option_size')) {
          if (avaiVariants.indexOf(data['variants'][i]['option_size']) == -1) {
            avaiVariants.push(data['variants'][i]['option_size']);
          }
        }
      }
      for (var k = 0; k < avaiVariants.length; k++) {
        var variant = data.variants.find(function(e){ return e.option_size == avaiVariants[k]; });
        if(variant.available){
          itemSwatchHtml += '<li id="' + variant.id + '" title="' + variant.inventory_quantity + ' In Stock" class="avactive"><a href="{{itemUrl}}?variant=' + variant.id + '">' + avaiVariants[k] + '</a></li> ';
        } else {
          itemSwatchHtml += '<li id="' + variant.id + '" title="Out of Stock"  class="notactve" >' + avaiVariants[k] + '</li> ';
        }
      }
      itemSwatchHtml += '</ul></div>';
    }
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    var langId = getLangId();
    var title = data.title;
    var metaTitle = this.getProductMetafield( data , langId , 'title' );
    if( metaTitle !== null)
      title = metaTitle;
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Add this function to bc-sf-filter.js
function getLangId() {
  var lang = $('#ly-slick-languages-switcher').find('.dd-selected-value').val();
    // if (lang == 'ly33580') lang = 'langshop';
    return lang;
}
/************************** END BUILD PRODUCT LIST **************************/

// Build Traditional Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ('#sortForm').html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<li class="sort manual"><a href="' + k + '" data-sort="manual"><span class="brackets skeleton-loading" data-trans-key="collections.sorting.manual">' + sortingArr[k] + '</span></a></li>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ('#sortForm').html(html);
        }
      
        var _this = this;
        jQ('#sortForm li a').each(function() {
            if (_this.queryParams.sort == jQ(this).attr('href')) {
                jQ('#sortButton').find('.brackets').text(jQ(this).text());
            }
        });
    }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
    var _this = this;
    jQ('#sortForm li a').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).attr('href'));
    })
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    initVertialMoreViewSlider('#bc-sf-filter-products');
    //lozadObj.observe();
    
    // Integrate Product Labels
    if (typeof SECOMAPP !== "undefined" && typeof SECOMAPP.pl !== "undefined") {
      //SECOMAPP.pl.labelCollections(true);
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    jQ('.template-search').addClass('template-collection');
  
  	if(typeof lozadObj != 'undefined'){
      	lozadObj.observe();
    }
  
  	initTranslate();
};

    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
